<template>
  <div>
    <div @click="Close" class="FullScr"></div>
    <div id="Modal-Content" :style="!InheritanceTheme ? 'background:#f2f8fa!important' : 'background:var(--sidebar-action-bg);'">
      <div class="slot-body" :style="!InheritanceTheme ? 'background:#f2f8fa!important' : 'background:var(--sidebar-action-bg);'">
        <div class="header" :style="!InheritanceTheme ? 'background:#fff!important' : 'background:var(--sidebar-action-bg);'">
          <span class="" @click="Close"><i class="fas fa-times fa-2x font-weight-bold Pointer ml-4 mr-3 mt-2" :class="!InheritanceTheme ? 'text-dark' : 'background:var(--sidebar-color-item);'"></i></span>
          <slot name="header"> </slot>
        </div>
        <div class="" :style="!InheritanceTheme ? 'background:#f2f8fa!important' : 'background:var(--sidebar-action-bg);'">
          <slot name="body"> </slot>
        </div>
        <div class="mt-5 p-2 footer px-4" v-if="IsFooter" :style="!InheritanceTheme ? 'background:#fff!important' : 'background:var(--sidebar-action-bg);'">
          <b-button id="CancelCopy" size="sm" variant="danger" class="ml-3" @click="Close"> بستن </b-button>
          <slot name="footer"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['InheritanceTheme', 'IsFooter', 'Size'],
  data() {
    return {}
  },
  mounted() {
    window.addEventListener('click', this.Clickhandler)
    if (this.Size == 'Xl') {
      document.getElementById('Modal-Content').style.width = '95vw'
      document.getElementById('Modal-Content').style.height = '90vh'
    } else if (this.Size == 'Lg') {
      document.getElementById('Modal-Content').style.width = '85vw'
      document.getElementById('Modal-Content').style.height = '80vh'
    } else if (this.Size == 'Md') {
      document.getElementById('Modal-Content').style.width = '65vw'
      document.getElementById('Modal-Content').style.height = '60vh'
    } else if (this.Size == 'Sm') {
      document.getElementById('Modal-Content').style.width = '40vw'
      document.getElementById('Modal-Content').style.height = '35vh'
    }
  },
  methods: {
    Close() {
      this.$store.state.Modal = false
      this.$emit('Close', true)
    },
    Clickhandler(e) {
      if (e.target.classList.contains('FullScr')) {
        this.Close()
      }
    },
  },
}
</script>
<style scoped>
#Modal-Content {
  /* display: block; */
  position: absolute;
  z-index: 1059 !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* max-width: 65vw;
  max-height: 80vh; */
  /* width: 65vw;
  height: 80vh; */
  overflow: auto !important;
  position: fixed;
  margin: auto;
  /* border:2px solid red; */
  border-radius: 8px;
  color: var(--sidebar-color-item) !important;
}

.FullScr {
  position: fixed !important;
  top: 0rem;
  left: 0rem;
  width: 100% !important;
  height: 100% !important;
  background: rgba(12, 12, 12, 0.745) !important;
  z-index: 15 !important;
}
small,
p,
h1,
h2,
h3,
h4,
h5,
span {
  color: var(--sidebar-color-item) !important;
}
.bg-Header {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}
.Body {
  background: var(--sidebar-color-item) !important;
}
.header {
  position: sticky !important;
  top: 0;
  z-index: 2000;
  padding-bottom: 3% !important;
}
.footer {
  width: 100%;
  position: unset !important;
  bottom: 0;
  z-index: 2000;
}
.fa-times:hover {
  color: red !important;
  transition: 0.3s;
}
.fa-times {
  transition: 0.3s;
}

@media screen and (max-width: 550px) {
  #Modal-Content {
    position: none !important;
    z-index: 9999 !important;
    overflow: auto !important;
    margin: auto;
    width: 90vw !important;
    /* border:2px solid red; */
    border-radius: 8px;
    color: var(--sidebar-color-item) !important;
  }
}
</style>
